// extracted by mini-css-extract-plugin
export default {"shrink":"Layout_shrink__3FhEG","fullHeight":"Layout_fullHeight__FP2iX","body":"Layout_body__5uO+H","showHorizontalScroll":"Layout_showHorizontalScroll__w1iyR"};